import { render, staticRenderFns } from "./RegisterPushDialog.vue?vue&type=template&id=40ada78b"
import script from "./RegisterPushDialog.vue?vue&type=script&lang=js"
export * from "./RegisterPushDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports